<script>
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import config from "@/config.js";
import Swal from "sweetalert2";
import { bus } from "@/main.js";
import loginCommonScriptMixin from "@/methods/loginCommonScriptMixin";
export default {
  mixins: [loginCommonScriptMixin],
  data() {
    return {
      swipeFlag: false,
      subscriptionEnabled: config.SUBSCRIPTION_ENABLED,
      features: null,
      // swipe
      swipeType: "",
      swipeFrom: "",
      swipeMessage: "",
      // snackbar
      snackObj: {
        snackbar: true,
        snackbarColor: "error",
        timeout: 6000,
        bottom: true,
        right: true,
        top: false,
        left: false,
        message: ""
      }
    };
  },
  computed: {
    computedCurrentRole() {
      return this.$store.getters["user/CURRENT_ROLE"];
    }
  },
  methods: {
    cityReplace(data) {
      if (data.city) data = data.city.replace( / +/g, '-')
      else if (data.state) data = data.state.replace( / +/g, '-')
      return data.toLowerCase()
    },
    // snackbar Func
    snackbarFunc(type, message) {
      this.snackObj.snackbar = true;
      this.snackObj.snackbarColor = type;
      this.snackObj.message = message;
      this.$store.dispatch("general/setSnack", this.snackObj);
    },
    swipMessageFun() {
      var self = this
      self.swipeFlag = true
      setTimeout(function () {
        self.swipeFlag = false
      }, 6000)
    },
    pinCodeCheck(pinCode){
      if (pinCode === '000001' || pinCode === 1) {
          var snackObj = {
                  snackbar: true,
                  snackbarColor: "error",
                  message: "Address with pin code required!"
                };
                this.$store.dispatch("general/setSnack", snackObj);
          return true
        }
        else return false
    },
    showSwipe(message, type, from) {
      this.swipeType = "";
      this.swipeFrom = "";
      this.swipeMessage = "";
      this.swipeType = type;
      this.swipeFrom = from;
      this.swipeMessage = message;
      this.swipMessageFun();
    },
    showImagePreview(image) {
      if (
        image == "/images/doctor-character-background_1270-84.jpg" ||
        image == "/images/default-user.png"
      ) {
        return false;
      } else return true;
    },
    getFeatures() {
      let role = this.computedCurrentRole;
      const url = `${config.NEW_BASE_URL}api/v2/features-by-role/${role}`;
      this.$http.get(url).then(response => {
        const { body } = response;
        if (body.status) {
          this.features = body.data.features;
        }
      });
    },
    getFeaturesPromise() {
      return new Promise(async resolve => {
        let role = this.computedCurrentRole;
        const url = `${config.NEW_BASE_URL}api/v2/features-by-role/${role}`;
        this.$http.get(url).then(response => {
          const { body } = response;
          if (body.status) {
            resolve(body.data.features);
          } else {
            resolve(null);
          }
        });
      });
    },
    routeToDigitalSignatureSetting() {
      this.$router.push({
        name: "settings.security.digital-signature"
      });
    },
    redirectOnMySubscription() {
      this.$router.push({
        name: "settings.subscription.my-subscription"
      });
    },
    redirectOnSubscription() {
      this.$router.push({
        name: "settings.subscription.my-subscription"
      });
    },
    redirectOnPlans(from) {
      if (from === "pendingTab")
        this.$router.push({
          name: "settings.subscription.plans",
          query: { pendingTab: true }
        });
      else this.$router.push({ name: "settings.subscription.plans" });
    },
    redirectOnAdvancePlan() {
      this.$router.push({
        name: "settings.subscription.plans",
        query: { advance: true }
      });
    },
    popUpForAdvancedSubscription() {
      this.$swal({
        title: "Info!",
        type: "warning",
        text: "To access this feature please subscribe to the Advance Plan",
        showCancelButton: true,
        cancelButtonText: "Close",
        confirmButtonText: "Subscribe",
        cancelButtonColor: "#f00",
        allowOutsideClick: false
      }).then(setPass => {
        if (setPass.value) {
          this.redirectOnAdvancePlan();
        }
      });
    },
    addDrPrefix: function (name) {
      if (name) {
        return name.includes("Dr. ") ? name : "Dr. " + name;
      }
    },
    openSwalMessage(message) {
      Swal.fire({
        toast: true,
        html: "<p> <b>" + message + "</b></p>",
        showCancelButton: false,
        showConfirmButton: false,
        position: "bottom",
        customClass: "bottom-swal",
        timer: 6000
      });
    },
    getAddress: function (obj) {
      if (obj.address_line_one) {
        return obj.address_line_one + ", " + obj.address_line_two + ". ";
      } else {
        return obj.address_line_two + ". ";
      }
    },
    forSearchDisplay: function (obj) {
      let address_lien_2 = obj.sublocality_level_2
        ? obj.sublocality_level_2 + ", "
        : "";
      let address_lien_1 = obj.sublocality_level_1
        ? obj.sublocality_level_1 + ", "
        : "";
      let city = obj.city + ". ";
      // if (obj.sublocality_level_2) {
      return address_lien_2 + address_lien_1 + city;
      // } else {
      //   return address_lien_2 + address_lien_1 + city;
      // }
    },
    getDirections(obj, showDirections = true) {
      bus.$emit("NAVIGATOR_GEO_CURRENT_LOADER", true);
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            bus.$emit("NAVIGATOR_GEO_CURRENT_LOADER", false);
            if (showDirections)
              window.open(
                `https://www.google.com/maps/dir/${latitude},${longitude}/${obj[1]},${obj[0]}`,
                "_blank"
              );
            resolve({ latitude, longitude });
          },
          err => {
            bus.$emit("NAVIGATOR_GEO_CURRENT_LOADER", false);
            this.$emit("error", "Cannot get Coordinates from navigator", err);
            reject(err);
          }
        );
      });
    },
    getYearList() {},
    getTime: function (time) {
      // time =
      //   parseFloat(time) < 12
      //     ? parseFloat(time).toFixed(2) + " AM"
      //     : (parseFloat(time) - 12 < 1
      //         ? parseFloat(time)
      //         : parseFloat(time) - 12
      //       ).toFixed(2) + " PM";
      // let timearray = time.split(" ");
      // let maintime = timearray[0].split(".");
      // let finaltime =
      //   (parseInt(maintime[0]) < 10 ? "0" + maintime[0] : maintime[0]) +
      //   "." +
      //   maintime[1] +
      //   " " +
      //   timearray[1];
      // return finaltime;
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    limitHospitalName(e) {
      var code = "charCode" in e ? e.charCode : e.keyCode;
      if (
        !(code == 32) && // space
        !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123) && // lower alpha (a-z)
        !(code == 39) && // (')
        !(code == 46)
      ) {
        // (.)
        e.preventDefault();
      }
    },
    limitName($event, value, maxLength, allow_space) {
      const keyCodeNotAllowSpace =
        ($event.keyCode < 97 || $event.keyCode > 122) &&
        ($event.keyCode < 65 || $event.keyCode > 90) &&
        $event.keyCode != 39;
      const keyCodeAllowSpace = keyCodeNotAllowSpace && $event.keyCode != 32;
      const checkMaxLength =
        value != undefined && value.toString().length >= maxLength;

      if (allow_space) {
        if (keyCodeAllowSpace || checkMaxLength) {
          $event.preventDefault();
        }
      } else {
        const keyCodeOfString = !isNaN(String.fromCharCode($event.keyCode));
        if (keyCodeNotAllowSpace || keyCodeOfString || checkMaxLength) {
          $event.preventDefault();
        }
      }
    },
    limitKeypress(
      $event,
      value,
      maxLength,
      allowDecimal = false,
      allowAlpha = false,
      allowSpecials = false
    ) {
      const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if ($event.keyCode === 32) {
        $event.preventDefault();
      }
      if (!allowSpecials && format.test(String.fromCharCode($event.keyCode))) {
        $event.preventDefault();
      }
      if (!allowAlpha && isNaN(String.fromCharCode($event.keyCode))) {
        if (allowDecimal && $event.keyCode !== 46) {
          $event.preventDefault();
        } else if (!allowDecimal) {
          $event.preventDefault();
        }
      }
      if (allowDecimal && value.includes(".") && $event.keyCode === 46) {
        $event.preventDefault();
      }
      if (
        value !== undefined &&
        value.toString().length >= maxLength &&
        !($event.target.selectionEnd - $event.target.selectionStart > 0)
      ) {
        $event.preventDefault();
      }
    },

    // Mixin for Downloading PDF wrt DOM ref
    downloadPDF: async function (domRef, fileName, orientation, format) {
      try {
        let png = await domtoimage.toPng(domRef);
        let doc = new jsPDF({
          orientation: orientation,
          unit: "mm",
          format: format
        });
        doc.addImage(png, "PNG", 0, 0);
        doc.save(fileName);
      } catch (error) {
        console.error("oops, something went wrong!", error);
      }
    },

    // Mixin for Printing PDF wrt DOM ref
    printPDF: async function (domRef, orientation, format) {
      try {
        let png = await domtoimage.toPng(domRef);
        let doc = new jsPDF({
          orientation: orientation,
          unit: "mm",
          format: format
        });
        doc.addImage(png, "PNG", 0, 0);
        doc.autoPrint();
        let file = doc.output("blob");
        var fileURL = URL.createObjectURL(file);
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.error("oops, something went wrong!", error);
      }
    },

    // Delete Method for s3 documents
    async getDeleteImg(data, cb, cmd) {
      await this.$swal({
        title: "Confirm deletion",
        text: "Are you sure, you want to delete this document?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonColor: "#f00",
        type: "warning",
        allowOutsideClick: false
      }).then(setPass => {
        if (setPass.value) {
          this.$store.commit("general/setLoadingGIF", true);
          this.$http
            .delete(`${config.NEW_BASE_URL}api/s3DeleteFile`, {
              body: data,
              header: {
                Authorization: `JWT ${localStorage.token}`
              }
            })
            .then(response => {
              this.showLoader = false;
              if (response.body.status) {
                this.$store.commit(
                  "general/setCertificateNameStatus",
                  data.entity_id
                );
                this.$store.commit("general/setLoadingGIF", false);
                this.$swal.fire({
                  toast: true,
                  html: "<p> <b>" + response.body.message + "</b></p>",
                  showCancelButton: false,
                  // cancelButtonText: "<i class='glyphicon glyphicon-remove'></i>",
                  showConfirmButton: false,
                  position: "bottom",
                  // allowOutsideClick: false,
                  // imageUrl: "/images/icons/error.png",
                  // imageWidth: 50,
                  // imageHeight: 55,
                  customClass: "bottom-swal",
                  timer: 6000
                });
              } else {
                // this.doctorCertificates = [];
                this.showLoader = false;
              }
            })
            .catch(err => {
              // this.doctorCertificates = [];
              this.showLoader = false;
            });
          if (typeof cb === "function") cb(cmd);
          return true;
        } else {
          console.log("inside else");
          return false;
        }
      });
    },

    // go to search method
    goToSearch(role) {
      window.location.href = `${config.NUXT_URL}${role}-search`;
    },

    // detect and correct slug of doctor
    slugDetectionCorrection(id) {
      return this.$http.get(
        `${config.NEW_BASE_URL}api/v2/${id}/slugify-doctor`
      );
    }
  }
};
</script>
